import { CommonModule } from '@angular/common';
import { Component, inject, Input } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AppService } from '@app/app.service';
import { ChangeStepService } from '@app/core/components/stepper/service/change-step.service';
import { CoreModule } from '@app/core/core.module';
import { FinancialProducts } from '@app/shared/interfaces/financial-simulator/financial-products.interface';
import { MockData } from '@app/shared/mocks/data.mock';
import { MockFinancialProducts } from '@app/shared/mocks/financial-products.mock';
import { ChangeDeviceService } from '@app/shared/services/change-device.service';
import { SaveDataService } from '@app/shared/services/save-data.service';
import { SharedModule } from '@app/shared/shared.module';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-secure-financing',
    standalone: true,
    imports: [CoreModule, CommonModule, SharedModule, TranslateModule],
    templateUrl: './secure-financing.component.html',
    styleUrl: './secure-financing.component.scss',
})
export class SecureFinancingComponent {
    private appData = inject(AppService);
    private saveData = inject(SaveDataService);

    continueButton = 'common.buttons.continueButton';
    backButton = 'common.buttons.backButton';

    secureFinancingTitle = 'features.secureFinancing.secureFinancingTitle';
    secureFinancingSubtitle = 'features.secureFinancing.secureFinancingSubtitle';
    without = 'features.secureFinancing.without';
    withoutInfo = 'features.secureFinancing.withoutInfo';
    withoutInfo2 = 'features.secureFinancing.withoutInfo2';

    totalProtection = 'features.secureFinancing.totalProtection';
    totalProtectionInfo = 'features.secureFinancing.totalProtectionInfo';
    totalProtectionInfo2 = 'features.secureFinancing.totalProtectionInfo2';
    totalProtectionInfo3 = 'features.secureFinancing.totalProtectionInfo3';

    //POPUP-CON SEGURO
    legalTextInsurance = 'features.secureFinancing.popupInsurance.legalTextInsurance';

    //POPUP-CON COBERTURA Y CONDICIONES
    legalTextCoverage = 'features.secureFinancing.popupCoverage.legalTextCoverage';

    visiblePopUpInsurance = false;
    visiblePopUpCoverage = false;

    backButtonDisabled = false;
    continueButtonDisabled = true;

    isPortraitDevice = false;

    firstMonthAmount: number;
    monthlyPrice: number;
    secureMonthlyPrice: number;
    securePriceTotal: number;
    financialProduct: FinancialProducts[] | null;
    secureName: string | undefined;

    formGroup!: FormGroup;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private changeDeviceService: ChangeDeviceService,
        private changeStepService: ChangeStepService,
        private fb: FormBuilder,
    ) {
        this.changeStepService.changeStep(18);
        // this.appData.data = MockData.createMockData();
        // this.appData.data.financialData.financialProducts = MockFinancialProducts.createMockFinancialProducts();
        this.firstMonthAmount = this.appData.data.financialData.installmentAndInsuranceFirstGrossAmount;
        this.monthlyPrice = this.appData.data.financialData.installmentMonthlyGrossAmount;
        this.secureMonthlyPrice = (Math.round((this.appData.data.financialData.installmentAndInsuranceTotalGrossAmount
            - this.appData.data.financialData.installmentMonthlyGrossAmount) * 100) / 100);
        this.securePriceTotal = this.appData.data.financialData.installmentAndInsuranceTotalGrossAmount;
        this.financialProduct = this.appData.data.financialData.financialProducts;
        this.secureName = this.financialProduct?.[0]?.cpiProducts?.[0]?.name;
    }

    ngOnInit() {
        this.isPortraitDevice = this.changeDeviceService.isPortraitDevice;
        this.changeDeviceService.changedDevice.subscribe((value) => {
            this.isPortraitDevice = value;
        });

        this.createForm();
        this.createLegalTextInsurance();
        //this.setValuesForm(this.saveDataService.data);

        //this.formIsValid();
    }

    createForm() {

        this.formGroup = this.fb.group({
            dni: [''],
        });

    }

    getAppData() {
        return this.appData;
    }

    //-------------------------//
    //--------NAVIGATION-------//
    //-------------------------//
/*
    onClicButtonBack() {
        this.router.navigate(['/main/step/additional-data-second'], { relativeTo: this.route });
    }
 */
    onClicButtonContinueWithout() {
        this.saveData.saveOperation().subscribe({
            next: (value) => {
                console.log("LLEGO LA LLAMADA");
                if (value) {
                    this.appData.data.operationData = value;
                    this.router.navigate(['/main/preauthorized'], { relativeTo: this.route });
                } else {
                    console.error("No se recibió ningún objeto Operation");
                }
                //console.log(this.financialProducts);
            },
            error: (err) => {
                console.error("Service 'saveOperation' emitted an error: " + err)
            },
            complete: () => {
                console.log("Service 'saveOperation' emitted the complete notification");
            },
        });

        //this.router.navigate(['/main/preauthorized'], { relativeTo: this.route });
    }

    onClicButtonContinueTotal() {
        //-FALTA-Pop-Up-Resumen confirmación solicitud financiación
        //this.router.navigate(['/main/preauthorized'], { relativeTo: this.route });

        //-FALTA-POP-UP
        this.visiblePopUpInsurance = true;
    }

    onClicButtonCoverage() {
        //-FALTA-POP-UP
        this.visiblePopUpCoverage = true;
    }

    onClosePopUpInsurance() {
        this.visiblePopUpInsurance = false;
    }

    onClosePopUpCoverage() {
        this.visiblePopUpCoverage = false;
    }

    createLegalTextInsurance () {
        const model = this.appData.data.vehicleData.model;
        const brand = this.appData.data.vehicleData.brand;
        const cost = this.appData.data.vehicleData.price;
        const financedAmount = this.appData.data.financialData.amountFinanced;
        const downPayment = this.appData.data.financialData.downPaymentGrossAmount;
        const aprcRate = this.appData.data.financialData.formalizationFee.percentage;
        const amountAprcRate = this.appData.data.financialData.formalizationFee.amount;
        const totalInterestGrossAmount = this.appData.data.financialData.totalInterestGrossAmount;
        const duracion = this.appData.data.financialData.duration;
        const lastCuote = this.appData.data.financialData.installmentLastGrossAmount;
        const tin = this.appData.data.financialData.nominalRate;
        const tae = this.appData.data.financialData.vat;
        const installmentMonthlyGrossAmount = this.appData.data.financialData.installmentMonthlyGrossAmount;
        const totalAmountDue = this.appData.data.financialData.totalAmountDue;
        const totalCreditCost = this.appData.data.financialData.totalCreditCost;
        const financedTotalAmount = this.appData.data.financialData.financedAndInsuranceTotalGrossAmount;

        this.legalTextInsurance = "Ejemplo de financiación para " + model + " " + brand + " PVP: " + cost
            + "€ (incluye IVA, transporte, impuesto de matriculación calculado al tipo general, "
            + "descuentos del concesionario y fabricante. Gastos de matriculación no incluidos)"
            + " Precio financiando: " + financedAmount + " €. "
            + "Entrada: " + downPayment + "€. Comisión de formalización del " + aprcRate + " % a pagar al contado: "
            + amountAprcRate + ". Importe financiado: " + totalAmountDue + "€.  " + duracion + " cuotas de "+ installmentMonthlyGrossAmount
            + "€ y una última cuota de " + lastCuote + "€. TIN " + tin  +"%. TAE "+ tae +"%. Total intereses: "
            + totalInterestGrossAmount + "€. Coste total del crédito: "+ totalCreditCost +"€. Importe total adeudado: "
            + this.securePriceTotal + "€. Precio total a plazos: " + financedTotalAmount
            + "€. Sistema de amortización francés. Financiación concertada bajo la marca Land Rover Financiar Services "
            + "(Marca registrada de JAGUAR LAND ROVER LIMITED) a través de Banco Cetelem S.A.U. para pedidos realizados "
            + "hasta el DD/MM/AAAA en Península y Baleares, y no sufrirá modificación salvo variación de los impuestos.";
    }

    ngOnDestroy() {}
}
